var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"uhv-loader u-align-center",class:[
    _vm.isVisible ? 'is-visible' : 'is-hidden',
    _vm.isActive ? 'is-active' : 'is-inactive'
  ]},[_c('uhv-svg-icon',{attrs:{"icon":"ecosystem-presente"}}),_c('uhv-svg-icon',{attrs:{"icon":"lhistoire-vrai-du-recyclage"}}),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"uhv-loader__footer"},[_c('div',{staticClass:"uhv-spinner"})])}]

export { render, staticRenderFns }